import { render, staticRenderFns } from "./comment_hotel.vue?vue&type=template&id=1742927a&scoped=true&"
import script from "./comment_hotel.vue?vue&type=script&lang=js&"
export * from "./comment_hotel.vue?vue&type=script&lang=js&"
import style0 from "./comment_hotel.vue?vue&type=style&index=0&id=1742927a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742927a",
  null
  
)

export default component.exports